// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"ec3e2879","104":"87d2531b","126":"e3df910f","411":"322de716","649":"826d58d1"}[chunkId] + ".chunk.js";
};